import { render, staticRenderFns } from "./aiBenHome.vue?vue&type=template&id=2b9a397a&scoped=true"
import script from "./aiBenHome.vue?vue&type=script&lang=js"
export * from "./aiBenHome.vue?vue&type=script&lang=js"
import style0 from "./aiBenHome.vue?vue&type=style&index=0&id=2b9a397a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9a397a",
  null
  
)

export default component.exports